import React from "react";
import slack from "../../../images/slack.svg";
import jira from "../../../images/jira.svg";
const JoinCompany = () => {
  return (
    <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-10 px-10 py-10">
      <div className="space-y-4">
        <h3 className="lg:text-3xl md:text-2xl text-xl font-bold text-black">
          Join over 1,000+ companies growing with knoct
        </h3>
        <p className="text-accent text-sm">
          Start your 30-day free trial today
        </p>
        <div className="space-x-3">
          <button className="lg:btn-md btn btn-sm btn-outline  btn-accent text-black">
            Learn more
          </button>
          <button className="lg:btn-md btn btn-sm btn-primary  text-white">
            Get started
          </button>
        </div>
      </div>
      <div className="flex justify-around">
        <ul className="space-y-3">
          <li className="flex gap-2 items-center">
            <img src={slack} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Slack</span>
          </li>
          <li className="flex gap-2 items-center">
            <img src={jira} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Jira</span>
          </li>
          <li className="flex gap-2 items-center">
            <img src={slack} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Slack</span>
          </li>
        </ul>
        <ul className="space-y-3">
          <li className="flex gap-2 items-center">
            <img src={jira} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Jira</span>
          </li>
          <li className="flex gap-2 items-center">
            <img src={slack} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Slack</span>
          </li>
          <li className="flex gap-2 items-center">
            <img src={jira} alt="" className="w-10" />
            <span className="text-2xl font-bold text-black">Jira</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default JoinCompany;
